export const DateRangeConstraints = {
  // FormDate Range constraints
  ENDDATE_IS_INVALID: 'end-date-is-invalid',
  STARTDATE_IS_INVALID: 'begin-date-is-invalid',
  STARTDATE_BEFORE_ENDDATE: 'begin-date-before-end-date',
  STARTDATE_EQUALS_ENDDATE: 'begin-date-equals-end-date',
};
/**
 * Special Validator for FormDateRange
 *
 * should implement a future validator class
 */
export default class DateRangeValidator {
  // params needed to be registerd in the constructor, as there was no
  // other way to get to the params in daterange.
  registerInputParameters(params) {
    this._params = params;
  }

  // we validate the private params here
  validate() {
    const issues = [];

    const startDate = this.getStartDate();
    const endDate = this.getEndDate();
    // different issues so we can focus date, hour or minute in the component

    // no problems here, endDate definitly bigger than begin
    if (endDate.getTime() > startDate.getTime()) {
      return issues;
    }
    // same date is ok if its allDay
    if (startDate.getTime() === endDate.getTime() && this.isAllDay()) {
      return issues;
    }

    if (Number.isNaN(startDate.valueOf())) {
      issues.push(DateRangeConstraints.STARTDATE_IS_INVALID);
    }

    if (Number.isNaN(endDate.valueOf())) {
      issues.push(DateRangeConstraints.ENDDATE_IS_INVALID);
    }

    if (startDate.getTime() >= endDate.getTime()) {
      issues.push(DateRangeConstraints.STARTDATE_BEFORE_ENDDATE);
    }

    return issues;
  }

  // for FormDateRange where the "isAllDay" checkbox is true
  // -> dont validate hour / minute
  isAllDay() {
    return this._params.isAllDay && this._params.isAllDay.value === true;
  }

  getStartDate() {
    return this.getDateFromParams(this._params.startDate.value);
  }

  getEndDate() {
    return this.getDateFromParams(this._params.endDate.value);
  }

  /**
   * Returning the Date object depending on isAllDay.
   *
   * isAllDay true -> parse date from toDateString which ignores hour/min/sec.
   * isAllDay false -> parsed dates with hour/min/sec information.
   */
  getDateFromParams(date) {
    return this.isAllDay() ? new Date(new Date(date).toDateString()) : new Date(date);
  }
}
